/* @flow */
import MessageDeliverySummary from 'entities/MessageDeliverySummary';
import Collection from 'lib/Collection';

export default class MessageDeliverySummaries extends Collection {
  initialize() {
    this.model = MessageDeliverySummary;
  }

  findWhereMessageId(messageId: string) {
    // This findWhere is provided by backbone-collection, NOT proxied to lodash
    // which is nice because findWhere has been removed in lodash 4
    return this.findWhere({ message_uuid: messageId });
  }
}



// WEBPACK FOOTER //
// ./src/collections/MessageDeliverySummaries.js